import * as tokens from '@audi/audi-ui-design-tokens';
import { responsiveSpacingTokens } from './audi-spacing';
import { responsiveTypography } from './audi-typography';
export const common = {
    breakpoints: {
        xs: tokens.BREAKPOINT_XS,
        s: tokens.BREAKPOINT_S,
        m: tokens.BREAKPOINT_M,
        l: tokens.BREAKPOINT_L,
        xl: tokens.BREAKPOINT_XL,
        xxl: tokens.BREAKPOINT_XXL,
    },
    easing: 'cubic-bezier(0.75, 0.02, 0.5, 1)',
    fontWeights: {
        normal: tokens.TYPOGRAPHY_FONT_WEIGHTS_NORMAL,
        bold: tokens.TYPOGRAPHY_FONT_WEIGHTS_BOLD,
    },
    fontFamily: tokens.TYPOGRAPHY_FONT_FAMILY,
    spacing: responsiveSpacingTokens,
    typography: responsiveTypography,
};
//# sourceMappingURL=audi-common.js.map